import Plyr from 'plyr';
export default (function () {
  // eslint-disable-next-line no-unused-vars
  var player = new Plyr('#player');
  player.on('ready', function () {
    player.toggleControls(false);
  });
});